import {OurFeedbackSvc} from '../services/OurFeedbackSvc';

class RandomFeedBack {
    currentFB: IFeedBack;
    loopTime: number = 0;
    private feedbacks: IFeedBack[];
    private timeoutLiner: ng.IPromise<any>;
    private step: number = 0;

    constructor(private OurFeedbackSvc: OurFeedbackSvc,
                private $scope: ng.IScope,
                private $timeout: ng.ITimeoutService) {

        this.feedbacks = this.OurFeedbackSvc.getForPage();
        this.changeLoop();
        $scope.$on('$destroy', () => $timeout.cancel(this.timeoutLiner));
    }

    changeLoop() {
        this.timeoutLiner = this.$timeout(() => {
            this.currentFB = this.feedbacks[this.step++];
            this.loopTime = this.currentFB.twit.length * 50;
            this.$timeout.cancel(this.timeoutLiner);
            if (this.step >= this.feedbacks.length) {
                this.step = 0;
            }
            this.changeLoop();
        }, this.loopTime);
    }
}
angular.module('animatronApp.feedback').component('randomFeedback', {
    controller: RandomFeedBack,
    controllerAs: 'randomFeedback',
    templateUrl: require('random-feedback.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/randomFeedbackDirective.ts